import React from 'react';

const ResearchPage = () => {
  return (
    <div className="research-page-container">
      <div className="research-heading">Research</div>

      {/* Buttons Section */}
      <div className="buttons-container">
        <button className="research-button">Research Domains</button>
        <button className="research-button">Research Projects</button>
        <button className="research-button">Laboratory Facilities</button>
        <button className="research-button">Collaborations</button>
      </div>
    </div>
  );
};

export default ResearchPage;